import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import VueFollowButton from '@/vue/public/VueFollowButton.vue';
import axios from 'axios';

//- フォローしている地域団体の型
interface FollowedBusiness {
  id: number;
  name: string;
}
export default /*@__PURE__*/_defineComponent({
  __name: 'VueFollowList',
  props: {
    isLoggedIn: { type: Boolean, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

;

const baseUrl = (window as any).baseUrl || '';
//- フォローしている地域団体の一覧を入れる箱
const followedBusinesses = ref<FollowedBusiness[]>([]);

//- スクロールする要素をrefで取得
const scrollContainer = ref<HTMLElement | null>(null);
//- スクロール可能かどうか
const isScrollable = ref<boolean>(false);
//- 前へスクロール可能かどうか
const canScrollPrev = ref<boolean>(false);
//- 次へスクロール可能かどうか
const canScrollNext = ref<boolean>(false);
//- スクロールバーの幅
const scrollThumbWidth = ref<number>(100);
//- スクロールバーの位置
const scrollThumbLeft = ref<number>(0);

const props = __props;





onMounted(() => {
  //- マウント時にフォローしている地域団体の一覧を取得
  fetchFollowedBusinesses();
  //- 画面幅が変わったとき、スクロール可能かどうかを再判定
  window.addEventListener('resize', updateScrollState);
});

onUnmounted(() => {
  //- コンポーネントが破棄されたらリサイズイベントを解除
  window.removeEventListener('resize', updateScrollState);
});

const fetchFollowedBusinesses = async () => {
  try {
    const response = await axios.get(`${baseUrl}/business-follow`);
    followedBusinesses.value = response.data.businesses;
    await nextTick();
    updateScrollState();
  } catch (error) {
    console.error(error);
  }
}

//- フォロー解除時の処理
const handleUnfollow = async (businessId: number) => {
  //- フォロー解除した地域団体を配列から削除
  followedBusinesses.value = followedBusinesses.value.filter(business => business.id !== businessId);
  await nextTick();
  updateScrollState();
}

//- スクロール状態を更新
const updateScrollState = () => {
  const scrollContainerElement = scrollContainer.value;
  if (!scrollContainerElement) return;

  //- スクロール対象の中身全体の幅(scrollWidth)から、表示されている幅(clientWidth)を引いた値
  const maxScrollLeft = scrollContainerElement.scrollWidth - scrollContainerElement.clientWidth;

  //- スクロールが必要なコンテンツ量かどうか
  //- カード幅の小数計算などで生じる1px以下の誤差は、スクロール可能と判定しない
  isScrollable.value = maxScrollLeft > 1;
  //- 現在位置が左端より右にあるなら「前へ」ボタンを有効化
  canScrollPrev.value = scrollContainerElement.scrollLeft > 0;
  //- 現在位置が右端に到達していないなら「次へ」ボタンを有効化
  //- -1 はブラウザの小数誤差対策
  canScrollNext.value = scrollContainerElement.scrollLeft < maxScrollLeft - 1;

  if (maxScrollLeft <= 0) {
    scrollThumbWidth.value = 100;
    scrollThumbLeft.value = 0;
    return;
  }


  //- スクロールバーのつまみ幅を計算
  //- 見えている範囲 ÷ 全体の幅
  //- 例: 1000px / 2000px = 50%
  scrollThumbWidth.value = (scrollContainerElement.clientWidth / scrollContainerElement.scrollWidth) * 100;

  //- スクロールバーの位置を計算
  //- 現在のスクロール割合 × バーが移動できる範囲
  //- 例: 50%スクロールしていて、つまみ幅が40%なら
  //-      50% × (100 - 40) = 30%
  scrollThumbLeft.value = (scrollContainerElement.scrollLeft / maxScrollLeft) * (100 - scrollThumbWidth.value);
}

// カード一覧を取得
const getScrollItems = () => {
  const scrollContainerElement = scrollContainer.value;
  if (!scrollContainerElement) return [];

  return Array.from(
    scrollContainerElement.querySelectorAll<HTMLElement>('.follow-businesses__item')
  );
}

// 現在のスクロール位置に一番近いスライドのインデックスを取得する関数
const getCurrentItemIndex = () => {
  const scrollContainerElement = scrollContainer.value;
  if (!scrollContainerElement) return 0;

  const items = getScrollItems();
  if (items.length === 0) return 0;

  const scrollPaddingLeft = 30;
  const currentLeft = scrollContainerElement.scrollLeft + scrollPaddingLeft;

  let currentIndex = 0;
  let shortestDistance = Math.abs(items[0].offsetLeft - currentLeft);

  items.forEach((item, index) => {
    const distance = Math.abs(item.offsetLeft - currentLeft);

    if (distance < shortestDistance) {
      shortestDistance = distance;
      currentIndex = index;
    }
  });

  return currentIndex;
}
// 指定したカードの場所へ移動する
const scrollToItem = (index: number) => {
  const scrollContainerElement = scrollContainer.value;
  if (!scrollContainerElement) return;

  const items = getScrollItems();
  const item = items[index];
  if (!item) return;

  const scrollPaddingLeft = 30;

  scrollContainerElement.scrollTo({
    left: item.offsetLeft - scrollPaddingLeft,
    behavior: 'smooth',
  });
}

// 次のカードに移動する
const scrollNext = () => {
  const items = getScrollItems();
  const currentIndex = getCurrentItemIndex();

  scrollToItem(Math.min(currentIndex + 1, items.length - 1));
}

// 前のカードに移動する
const scrollPrev = () => {
  const currentIndex = getCurrentItemIndex();

  scrollToItem(Math.max(currentIndex - 1, 0));
}

const __returned__ = { baseUrl, followedBusinesses, scrollContainer, isScrollable, canScrollPrev, canScrollNext, scrollThumbWidth, scrollThumbLeft, props, fetchFollowedBusinesses, handleUnfollow, updateScrollState, getScrollItems, getCurrentItemIndex, scrollToItem, scrollNext, scrollPrev, ref, onMounted, onUnmounted, nextTick, VueFollowButton, get axios() { return axios } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})